import { HardwareModels } from "types/productTypes";

const VENDOR_APK_PREFIXES: Partial<Record<HardwareModels, string>> = {
  [HardwareModels.Dpvr]: "oculera_dp",
  [HardwareModels.HtcFocusVision]: "oculera_htc",
};

const getApkPrefix = (model: HardwareModels | null): string =>
  (model && VENDOR_APK_PREFIXES[model]) ?? "oculera";

export function getVersionedApkFilename(model: HardwareModels | null, version: string): string {
  const versionToken = version.replace(/\./g, "_").replace(/[^0-9A-Za-z_-]/g, "");
  return `${getApkPrefix(model)}_${versionToken}.apk`;
}
